import styled from 'styled-components';
import GameButtonStyled from '../../atoms/GameButton/GameButton.styled';

export const ModalBg = styled.section`
  background: rgba(0, 0, 0, 0.7);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: ${props => props.theme.zIndex.overlay};
`;

export const ModalButton = styled(GameButtonStyled)`
  bottom: -23px;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);

  &:focus,
  &:active,
  &:not([disabled]):active {
    transform: translate(-50%, 2px);
  }
`;

export const ModalTitle = styled.h3`
  color: ${props => props.theme.colors.tertiary};
  font-size: calc(${props => props.theme.fonts.baseSize} + 0.8vmin);
  margin: 30px 20px 0;
  text-transform: uppercase;
`;

export const ModalText = styled.p`
  font-size: calc(${props => props.theme.fonts.baseSize} + 0.2vmin);
  line-height: 1.5;
  margin: 0;
  padding: 20px;
`;

const ModalStyled = styled.section`
  background: ${props => props.theme.colors.white};
  border-radius: 10px;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.5);
  color: ${props => props.theme.colors.dark};
  left: 50%;
  max-width: 300px;
  padding: 20px 20px 30px;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  z-index: ${props => props.theme.zIndex.overlay + 1};

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    padding: 30px 30px 50px;
    width: 100%;
  }
`;

export default ModalStyled;



// WEBPACK FOOTER //
// ./src/components/molecules/Modal/Modal.styled.js